<div class="flex flex-col items-center justify-center gap-2">
  @if (message()) {
    <span
      class="text-[10px] text-base-content/30 tracking-widest uppercase"
      style="font-family: archive-regular"
      >{{ message() }}</span
    >
  }
  <span class="text-base-content/25 loading loading-ring loading-md"></span>
</div>
